import { Configuration } from "./configuration.model";

class ConfigurationService {
	private configuration!: Configuration;

	async load(): Promise<void> {
		try {
			const response = await fetch("/run-time.json");
			this.configuration = await response.json();
		} catch (error) {
			this.configuration = {
				deployInProgress: false
			};
		}
	}

	public get value(): Configuration {
		return this.configuration;
	}
}

export default new ConfigurationService();
